import * as React from 'react';
import DetailsCard from '../common/DetailsCard';
import { formatCurrency } from '../../CurrencyUtils';
import { percentageDifference } from '../../NumberUtils';
import './style/index.scss';
export const PAY_HISTORY_DEFAULT_DATA_POINTS = 5;
export class PayHistorySummaryCard extends React.PureComponent {
    render() {
        return (React.createElement(DetailsCard, { className: "pay-history-summary-card" }, this._getSummary()));
    }
    _getIncDecText(d1, d2) {
        const { currency, employeeName } = this.props;
        const direction = d2.baseSalary > d1.baseSalary ? 'increased' : 'decreased';
        let rangeText = '';
        const rangeYears = this._getDiffYears(new Date(), new Date(d2.createdAt));
        if (rangeYears === 0) {
            rangeText = 'this year';
        }
        else if (rangeYears === 1) {
            rangeText = '1 year ago';
        }
        else {
            rangeText = `${rangeYears} years ago`;
        }
        return (React.createElement("span", null,
            React.createElement("span", null,
                React.createElement("span", { className: "sensitive-info" }, employeeName),
                `'s pay ${direction} from `),
            React.createElement("span", { className: "pay-history-summary-card--bold" }, formatCurrency(d1.baseSalary, currency)),
            React.createElement("span", null, " to "),
            React.createElement("span", { className: "pay-history-summary-card--bold" }, formatCurrency(d2.baseSalary, currency)),
            React.createElement("span", null,
                " ",
                rangeText,
                ".")));
    }
    _getSummary() {
        const { employeeName, historyDataPoints, maxDataPoints } = this.props;
        if (!historyDataPoints) {
            return (React.createElement("div", { className: "pay-history-summary-card__description" },
                React.createElement("span", { className: "sensitive-info" },
                    employeeName,
                    " "),
                "does not have any pay history data."));
        }
        if (historyDataPoints.length < 2) {
            return (React.createElement("div", { className: "pay-history-summary-card__description" },
                React.createElement("span", { className: "sensitive-info" },
                    employeeName,
                    " "),
                "does not have enough pay history data."));
        }
        let tempDataPoints = historyDataPoints;
        tempDataPoints.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt));
        tempDataPoints = tempDataPoints.slice(-(maxDataPoints || PAY_HISTORY_DEFAULT_DATA_POINTS));
        const firstDataPoint = tempDataPoints[0];
        const lastDataPoint = tempDataPoints[tempDataPoints.length - 1];
        const secondLastDataPoint = tempDataPoints[tempDataPoints.length - 2];
        const rangeYears = this._getDiffYears(new Date(lastDataPoint.createdAt), new Date(firstDataPoint.createdAt)) + 1;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "pay-history-summary-card__description-recent" }, this._getIncDecText(secondLastDataPoint, lastDataPoint)),
            React.createElement("div", { className: "pay-history-summary-card__percentage-description" },
                "This is",
                lastDataPoint.baseSalary > secondLastDataPoint.baseSalary ? ' an increase ' : ' a decrease ',
                "of"),
            React.createElement("div", { className: "pay-history-summary-card__percentage" },
                Math.abs(percentageDifference(secondLastDataPoint.baseSalary, lastDataPoint.baseSalary, 1)),
                "%"),
            historyDataPoints.length > 2 &&
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "pay-history-summary-card__description-five-years" },
                        "In the last",
                        React.createElement("span", { className: "pay-history-summary-card--bold" },
                            " ",
                            rangeYears,
                            " "),
                        "years,",
                        React.createElement("span", { className: "sensitive-info" },
                            " ",
                            employeeName),
                        "'s pay has",
                        lastDataPoint.baseSalary > firstDataPoint.baseSalary ? ' increased' : ' decreased'),
                    React.createElement("div", { className: "pay-history-summary-card__percentage" },
                        Math.abs(percentageDifference(firstDataPoint.baseSalary, lastDataPoint.baseSalary, 1)),
                        "%"))));
    }
    _getDiffYears(date1, date2) {
        return Math.abs(date1.getUTCFullYear() - date2.getUTCFullYear());
    }
}
export default PayHistorySummaryCard;
